import React from 'react';
import './SummaryPanel.css';

// Helper function to format numbers as integers with commas
const formatNumber = (num, unit = '') => {
  if (typeof num !== 'number') return `– ${unit}`;
  const roundedNum = Math.round(num);
  return `${roundedNum.toLocaleString()} ${unit}`;
};

const SummaryPanel = ({ data }) => {
  
  const showHelpPopup = () => {
    const message = `
【計算式の注釈】

■ 電力支出予測（当日市場）
夜間蓄電や太陽光を考慮せず、すべての電力需要を時間前価格で購入した場合の理論上の総コストです。
計算式: Σ (時間ごと電力需要量 × 時間ごと時間前価格)

■ 電力支出予測（スポット市場）
夜間蓄電や太陽光発電を最適活用した場合の、スポット市場での電力の純支出額です。
計算式: Σ (時間ごと買電量 × 時間ごとスポット価格) - Σ (時間ごと売電量 × 時間ごとスポット価格)

■ 節約額
スポット市場で取引した場合に、当日市場で全量購入するより、どれだけ支出を抑えられるかを示した期待値です。
計算式: [電力支出予測（当日市場）] - [電力支出予測（スポット市場）]
    `;
    alert(message.trim());
  };

  const summary = data?.summary;

  if (!summary) {
    return (
      <div className="summary-panel-container">
        <div className="summary-cards-wrapper">
          <div className="summary-item">データがありません</div>
        </div>
        <button className="help-btn" onClick={showHelpPopup}>？</button>
      </div>
    );
  }
  
  const { spotCost, expectedSaving, realtimeCost, totalPurchase, totalSale, totalConsumption, totalGeneration } = summary;

  // 割合を計算
  const savingRate = realtimeCost > 0 ? (expectedSaving / realtimeCost) * 100 : 0;

  return (
    <div className="summary-panel-container">
      <div className="summary-cards-wrapper">
        {/* --- 1列目 --- */}
        <div className="summary-column">
          <div className="main-line">
            <span className="main-label">電力支出予測</span>
            <span className="main-value emphasized">{formatNumber(spotCost, '円')}</span>
          </div>
          <div className="sub-line">（スポット市場での取引）</div>
        </div>

        {/* --- 2列目 --- */}
        <div className="summary-column">
          <div className="main-line">
            <span className="main-label">節約額</span>
            <span className="main-value emphasized profit">
              {formatNumber(expectedSaving, '円')}
              <span className="saving-rate">{`(${savingRate.toFixed(1)}%削減)`}</span>
            </span>
          </div>
          <div className="sub-line">（当日取引と比較した節約期待値）</div>
        </div>

        {/* --- 3列目 (参考) --- */}
        <div className="summary-column reference-column">
          <div className="main-line">
            <span className="main-label">参考 最大支出予測</span>
            <span className="main-value">{formatNumber(realtimeCost, '円')}</span>
          </div>
          <div className="sub-line">（当日市場で全て取引した場合の最大値）</div>
        </div>

        {/* --- 4列目 (追加メトリクス) --- */}
        <div className="summary-column additional-metrics">
            <div className="metric-item-small">
                <span className="metric-label-small">買電量合計</span>
                <span className="metric-value-small">{formatNumber(totalPurchase, 'kWh')}</span>
            </div>
            <div className="metric-item-small">
                <span className="metric-label-small">売電量合計</span>
                <span className="metric-value-small">{formatNumber(totalSale, 'kWh')}</span>
            </div>
            <div className="metric-item-small">
                <span className="metric-label-small">消費量合計</span>
                <span className="metric-value-small">{formatNumber(totalConsumption, 'kWh')}</span>
            </div>
            <div className="metric-item-small">
                <span className="metric-label-small">発電量合計</span>
                <span className="metric-value-small">{formatNumber(totalGeneration, 'kWh')}</span>
            </div>
        </div>
      </div>
      <button className="help-btn" onClick={showHelpPopup}>？</button>
    </div>
  );
};

export default SummaryPanel; 